import { IconButton } from '@chakra-ui/react';
import ChevUpIcon from 'components/atoms/Icon/checkUp';
import { has } from 'lodash';
import React from 'react';
import InnerImageZoom from 'react-inner-image-zoom';
import 'react-inner-image-zoom/lib/InnerImageZoom/styles.min.css';
import { scroller } from 'react-scroll';
import Slick from 'react-slick';
import Slider from '../../atoms/Slider/Slider';
import * as styles from './ProductImages.module.css';

function CustomButton(props) {
  const { onClick, customClass, className } = props;

  return (
    <IconButton
      rounded={'full'}
      variant="ghost"
      className={`${customClass} ${className.includes('disabled') ? 'disabled' : ''}`}
      onClick={onClick}
      color={'var(--charcoal-02)'}
      icon={<ChevUpIcon />}
    />
  );
}

const ProductImages = React.forwardRef(({
  sortedImages,
  identifier,
  type,
  product,
  imageStyling,
  igRef,
  activeIndex,
  setActiveIndex,
  output = 'slider'
}, ref) => {
  const thumbNailSettings = {
    dots: false,
    infinite: false,
    slidesToShow: 6,
    slidesToScroll: 1,
    vertical: true,
    verticalSwiping: true,
    nextArrow: <CustomButton customClass="slick-down" />,
    prevArrow: <CustomButton customClass="slick-up" />
  };

  // const [sortedImages, setSortedImages] = useState([]);

  const customPaging = () => {
    return <div className={styles.mobilePagination}></div>;
  };

  const onClickThumbScroller = evt => {
    evt.preventDefault();
    if (window.innerWidth > 767) {
      scroller.scrollTo(evt.currentTarget.getAttribute('href').replace('#', ''), {
        duration: 800,
        delay: 0,
        offset: -180,
        smooth: 'easeInOutQuart'
      });
    } else {
      const _parent = document.querySelector(
        `.${evt.currentTarget.getAttribute('data-image-class')}`
      ).parentElement;
      document
        .querySelectorAll(`.${evt.currentTarget.getAttribute('data-image-class')}`)
        .forEach((_el, _index) => {
          _el.classList.remove(evt.currentTarget.getAttribute('data-image-class'));
        });

      _parent
        // .querySelectorAll('img')
        .querySelectorAll('.productImageContainer')
        [parseInt(evt.currentTarget.getAttribute('data-key'), 10)].classList.add(
          evt.currentTarget.getAttribute('data-image-class')
        );
    }

    return false;
  };

  const onClickThumbSlider = index => {
    // if (igRef?.current !== undefined) {
    //   igRef.current.slickGoTo(index);
    // }
    setActiveIndex(index);
  };

  const sliderSettings = {
    infinite: false,
    slidesToShow: 2,
    arrows: false,
    speed: 150,
    fade: true,
    dotsClass: `${styles.customDots}`,
    swipe: true,
    dots: true,
    customPaging: customPaging
  };

  const thumbnailOptions = index => {
    if (output === 'scroller') {
      return {
        onClick: onClickThumbScroller,
        href: `#${identifier}-${index + 1}`
      };
    }

    if (output === 'slider') {
      return {
        onClick: () => onClickThumbSlider(index)
      };
    }

    return null;
  };

  return (
    <>
      {!!sortedImages && sortedImages.length > 0 && (
        <>
          {type === 'thumbnails' && sortedImages && sortedImages.length > 1 && (
            <Slick {...thumbNailSettings}>
              {sortedImages.map((img, index) => (
                <a
                  {...thumbnailOptions(index)}
                  role="presentation"
                  key={index}
                  data-key={index}
                  data-image-class={styles.productImageActive}
                  className={`${styles.productImageThumb} ${
                    activeIndex === index ? styles.activeThumbnail : ''
                  }`}
                >
                  <img
                    loading="lazy"
                    src={has(img, 'node') ? img.node.url : img.url_thumbnail}
                    alt={img.description || product?.name}
                  />
                </a>
              ))}
            </Slick>
          )}

          {type === 'gallery' &&
            output === 'scroller' &&
            sortedImages &&
            sortedImages.map((img, index) => (
              <div
                id={`${identifier}-${index + 1}`}
                key={index}
                className={`productImageContainer ${index === 0 ? styles.productImageActive : ''}`}
              >
                <InnerImageZoom
                  src={
                    has(img, 'node')
                      ? img.node.url
                      : has(img, 'url_zoom')
                      ? img.url_zoom
                      : img.url_standard
                  }
                  zoomSrc={
                    has(img, 'node')
                      ? img.node.url
                      : has(img, 'url_zoom')
                      ? img.url_zoom
                      : img.url_standard
                  }
                  alt={img.description || product?.name}
                />
              </div>
            ))}
          {type === 'gallery' && output === 'slider' && sortedImages && sortedImages.length > 0 && (
            <>
              <div className={styles.desktopImage}>
                <img
                  className={imageStyling !== undefined ? imageStyling : ''}
                  src={
                    has(sortedImages[activeIndex], 'node')
                      ? sortedImages[activeIndex].node.url
                      : has(sortedImages[activeIndex], 'url_zoom')
                      ? sortedImages[activeIndex]?.url_zoom
                      : sortedImages[activeIndex]?.url_standard
                  }
                  alt={sortedImages[activeIndex]?.description || product?.name}
                />
              </div>
              <div className={styles.mobileSlider}>
                <Slider settings={sliderSettings} sliderRef={igRef}>
                  {sortedImages.map((img, index) => (
                    <div key={index}>
                      <img
                        alt={img.description || product?.name}
                        className={styles.mobileImage}
                        src={has(img, 'node') ? img.node.url : img.url_standard}
                      ></img>
                    </div>
                  ))}
                </Slider>
              </div>
            </>
          )}
        </>
      )}
      {type === 'gallery' && (!sortedImages || sortedImages.length === 0) && (
        <div>
          <img
            loading="lazy"
            src="https://via.placeholder.com?1000x1000?text=No+Images+Available"
            alt="No product images"
          />
        </div>
      )}
    </>
  );
});

export default ProductImages;
